import { PwaContext } from "../components/PwaProvider.js";
import { useContext } from "react";

//#region src/hooks/use-pwa-context.ts
const usePwaContext = () => {
	return useContext(PwaContext);
};

//#endregion
export { usePwaContext };